import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'ui-avatar',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [
    `
      :host {
        display: inline-block;
        border-radius: 50%;
        overflow: hidden;
        flex-shrink: 0;
        line-height: 1;
        background-color: #e5e7eb;
      }
      img {
        object-fit: cover;
        aspect-ratio: 1 / 1;
        border-radius: 50%;
      }
      .avatar-placeholder {
        /* This is the text fallback (e.g., "IS") */
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        border-radius: 50%;
        background-color: #e5e7eb; /* A light gray */
        color: #6b7280;
        font-weight: 500;
        font-size: 0.875rem;
        text-transform: uppercase;
      }
    `,
  ],
  template: `
    @if (imageUrl(); as url) {
      <img [src]="url" [width]="sizeMap[size()]" [height]="sizeMap[size()]" [alt]="altText() || 'User avatar'" />
    } @else {
      <span class="avatar-placeholder" [style.width.px]="sizeMap[size()]" [style.height.px]="sizeMap[size()]">
        {{ (altText() ? altText().charAt(0) : '') || 'U' }}
      </span>
    }
  `,
})
export class AvatarComponent {
  imageUrl = input<string>();
  altText = input<string>();
  size = input<'sm' | 'md' | 'lg'>('md');

  readonly sizeMap: { [key in 'sm' | 'md' | 'lg']: number } = {
    sm: 24,
    md: 32,
    lg: 40,
  };
}

